export type ElementStyle = {
  property: string;
  value: string | null;
  priority?: string;
};

export type ElementAttribute = {
  name: string;
  value: string;
};

export const createHtmlElement = (type: string, styles?: ElementStyle[], attributes?: ElementAttribute[]) => {
  const element = document.createElement(type);
  styles?.forEach(({ property, value, priority }) => {
    element.style.setProperty(property, value, priority);
  });
  attributes?.forEach(({ name, value }) => {
    element.setAttribute(name, value);
  });
  return element;
};
